import axios from 'axios';
import axiosInstance from '.';

const BASE = '/v1/ride-24';

export const assetUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const base = process.env.REACT_APP_TAURIAN_ASSET_URL || '';
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};

export const getMe = () => axiosInstance.get(`${BASE}/me`);

export const updateMe = (data) => axiosInstance.patch(`${BASE}/me`, data);

export const getMyRides = (params = {}) =>
  axiosInstance.get(`${BASE}/me/rides`, { params });

export const listEvents = (params = {}) =>
  axiosInstance.get(`${BASE}/events`, { params });

export const createEvent = (data) => axiosInstance.post(`${BASE}/events`, data);

export const getEvent = (id) => axiosInstance.get(`${BASE}/events/${id}`);

export const updateEvent = (id, data) =>
  axiosInstance.patch(`${BASE}/events/${id}`, data);

export const cancelEvent = (id, data) =>
  axiosInstance.post(`${BASE}/events/${id}/cancel`, data);

export const getEventRsvps = (id) =>
  axiosInstance.get(`${BASE}/events/${id}/rsvps`);

export const getEventParticipants = (id) =>
  axiosInstance.get(`${BASE}/events/${id}/participants`);

export const removeEventParticipant = (eventId, userId) =>
  axiosInstance.delete(`${BASE}/events/${eventId}/participants/${userId}`);

export const getEventChat = (id, { skipLoader = false } = {}) =>
  axiosInstance.get(`${BASE}/events/${id}/chat`, { skipLoader });

export const postEventChat = (id, data) =>
  axiosInstance.post(`${BASE}/events/${id}/chat`, data);

export const rsvp = (data) => axiosInstance.post(`${BASE}/rsvp`, data);

export const applyOrganiser = (data) =>
  axiosInstance.post(`${BASE}/organiser/apply`, data);

export const getOrganiserMe = () => axiosInstance.get(`${BASE}/organiser/me`);

export const getTerms = () => axiosInstance.get(`${BASE}/terms`);

export const getPresignedUrl = ({ key, type, isPrivate = false }) =>
  axiosInstance.get(`${BASE}/uploads/presigned-url`, {
    params: {
      key,
      type,
      ...(isPrivate ? { private: 'true' } : {}),
    },
  });

export const confirmUpload = (data) =>
  axiosInstance.post(`${BASE}/uploads/confirm`, data);

export const getPrivateUrl = (path) =>
  axiosInstance.get(`${BASE}/uploads/private-url`, { params: { path } });

/**
 * Presign → PUT → confirm. Returns { path, content_type, size }.
 */
export const uploadFile = async (file, { isPrivate = false } = {}) => {
  const key = `${Date.now()}-${file.name.replace(/[^a-zA-Z0-9._-]/g, '_')}`;
  const { data: presign } = await getPresignedUrl({
    key,
    type: file.type || 'application/octet-stream',
    isPrivate,
  });

  const uploadUrl = presign.url;
  const storagePath = presign.key || presign.path || key;

  await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
  });

  const { data: confirmed } = await confirmUpload({
    path: storagePath,
    content_type: file.type || 'application/octet-stream',
    size: file.size,
    original_filename: file.name,
    is_private: isPrivate,
  });

  return {
    path: confirmed.path || storagePath,
    content_type: confirmed.content_type || file.type,
    size: confirmed.size ?? file.size,
  };
};
